// import { GameData } from "../../firecubes/gamestate/gameData";
// import { playButtunClick } from "../../firecubes/inGameFunction";
// import { CommonData } from "../datastructures/gamestate/gameData";

export class HoldPressedCircularBtn {
    private rootParent: PIXI.Container = new PIXI.Container();
  private parent: PIXI.Container = new PIXI.Container();
  private halfCircle: Array<PIXI.Graphics> = [];
  private masks: Array<PIXI.Graphics> = [];
  private tweenSpinHalf: Array<PIXI.tween.Tween> = [];
  private holdComplete: PIXI.tween.Tween;
  private size: number = 100;
  private started:boolean=false;

  private defaultRotation:number=-90*Math.PI/180;

  //Creates a btn at the center of the screen then need to be call setVisible function to make it clickable so taht it shows up
  constructor(parent: PIXI.Container) {
    parent.addChild(this.rootParent);
    this.rootParent.addChild(this.parent);
    this.rootParent.rotation=this.defaultRotation;
    for (let i = 0; i < 2; i++) {
      this.halfCircle[i] = new PIXI.Graphics();
      this.masks[i] = new PIXI.Graphics();

      this.halfCircle[i].lineStyle(20, 0xfffa7b, .7);
      this.halfCircle[i].arc(0, 0, this.size, 0, Math.PI); // cx, cy, radius, startAngle, endAngle

      // this.halfCircle[i].position = {x: sW/2, y: sH/2};

      this.parent.addChild(this.halfCircle[i]);

      this.masks[i]
        .beginFill(0xfffa7b, .9)
        .drawRect(
          -this.size * 1.5,
          -this.size * 1.5,
          this.size * 3,
          this.size * 1.5
        )
        .endFill();
      this.parent.addChild(this.masks[i]);
      //-
      if (i == 0) {
        this.halfCircle[i].rotation = Math.PI;
        this.masks[i].rotation = Math.PI;
      }

      ////--
      // create tween for half

      this.tweenSpinHalf[i] = PIXI.tweenManager.createTween(this.halfCircle[i]);

      if (i == 0) {
        this.tweenSpinHalf[i]
          .from({ rotation: Math.PI })
          .to({ rotation: Math.PI * 2 });
      } else {
        this.tweenSpinHalf[i].from({ rotation: 0 }).to({ rotation: Math.PI });
      }
      this.tweenSpinHalf[i].time = 500;
      this.tweenSpinHalf[i].loop = false;
      this.tweenSpinHalf[i].easing = PIXI.tween.Easing.linear();
    }


    this.setPosition(1920/2 , 1080/2);
    //create the endTween
    this.holdComplete = PIXI.tweenManager.createTween(this.parent);  
    this.holdComplete.from({ scale:{x:1,y:1},alpha:1 }).to({scale:{x:1.5,y:1.5},alpha:0 })
    this.holdComplete.time = 700;
    this.holdComplete.loop = false;
    this.holdComplete.easing = PIXI.tween.Easing.outExpo();


    //-chain tween
    this.tweenSpinHalf[0].chain(this.tweenSpinHalf[1]);
    this.tweenSpinHalf[1].chain(this.holdComplete);
    //set maskTarget
    this.halfCircle[0].mask = this.masks[0];
    this.halfCircle[1].mask = this.masks[1];

    //-define functions for btn
    this.parent.on("pointerdown", this.onHoldStart);
    this.parent.on("pointerout" && "pointerup", this.onHoldStopped);
    
    this.setVisible(false);
  }
   public SetOnCompleteFunction=(newFn: Function):void=>
   {
    this.tweenSpinHalf[1].on("end",newFn)
   }
  public setVisible = (bool: boolean): void => {
    this.setClickable(bool);
    this.parent.alpha = 0 ;
  };

  public setDuration=(newDurationInMs:number):void=>
  {
    for (let i = 0; i < this.tweenSpinHalf.length; i++) {
      this.tweenSpinHalf[i].time = newDurationInMs/2;
      
    }
  }
  private setClickable = (bool: boolean): void => {
    this.parent.buttonMode = bool;
    this.parent.interactive = bool;
    this.started=false;
  };
  public onHoldStopped = (): void => {

    // console.log('exit')
    this.resetElements();
    this.started=false;
  };

  private resetElements=():void=>
  {
    this.holdComplete.stop();
    this.holdComplete.reset();
    this.parent.alpha=0;
    this.parent.scale.set(1);
    this.halfCircle[0].rotation = Math.PI;
    this.halfCircle[1].rotation = 0;
    this.tweenSpinHalf[0].stop();
    this.tweenSpinHalf[1].stop();
    this.tweenSpinHalf[0].reset();
    this.tweenSpinHalf[1].reset();
  }
  public onHoldStart = (): void => {
    // console.log("started")
    if(this.started==false)
    {   
        this.started=true;
        this.resetElements();
        this.parent.alpha=1;
        this.tweenSpinHalf[0].start();
    }

  };
  public setPosition = (newPOsX: number, newPosY: number): void => {
    this.parent.x = newPOsX;
    this.parent.y = newPosY;
  };

  public setScale = (newScale: number): void => {
  this.rootParent.scale.set(newScale)
  };
}

export class ToggleSwitch {
  private parent: PIXI.Container;
  private switchColorA: PIXI.Sprite;
  private isOn: boolean;
  private switchColorB: PIXI.Sprite;
  // private activeGameData: CommonData;
  private switchPosCircle: PIXI.Sprite;
  private bgColorTweenON: PIXI.tween.Tween;
  private bgColorTweenOFF: PIXI.tween.Tween;
  private switchCircleTweenON: PIXI.tween.Tween;
  private switchCircleTweenOFF: PIXI.tween.Tween;
  private label: PIXI.Text;

  constructor(label: string) {
    this.parent = new PIXI.Container();
    this.switchColorA; //Default Body of switch;
    this.switchColorB;
    this.switchPosCircle;
    //Animation Tweens on click
    this.bgColorTweenON;
    this.bgColorTweenOFF;
    this.switchCircleTweenON;
    this.switchCircleTweenOFF;
    // this.activeGameData = activeGameData;
    this.label = new PIXI.Text(label, {
      fontFamily: "Tahoma, Helvetica, sans-serif",
      fontWeight: "bold",
      fontSize: 30,
      fill: "white",
      align: "left",
      wordWrap: true,
      wordWrapWidth: 1600,
      lineHeight: 100,
    });

    this.createGraphics();
    this.createTweens();

    this.isOn = false; //off;
  }
  private createGraphics = (): void => {
    this.switchColorA = new PIXI.Sprite(
      PIXI.Texture.fromImage("toggleBtnOff.png")
    );
    this.switchColorA.anchor.set(0.75, 0.5);

    this.switchColorA.interactive = true;
    this.switchColorA.buttonMode = true;
    // this.switchColorA.on('pointertap', this.changeState.bind(this),false);//Base Function that animate and change isOn state

    this.switchColorA.hitArea = new PIXI.Rectangle(-130, -50, 260, 100);
    this.switchColorB = new PIXI.Sprite(
      PIXI.Texture.fromImage("toggleBtnOn.png")
    );
    this.switchColorB.anchor.set(0.75, 0.5);

    this.switchColorB.alpha = 0;
    this.switchColorA.addChild(this.switchColorB);

    this.switchPosCircle = new PIXI.Sprite(
      PIXI.Texture.fromImage("toggleBtn.png")
    );
    this.switchPosCircle.anchor.set(0.5);
    this.switchColorA.addChild(this.switchPosCircle);
    this.switchPosCircle.x = -55;

    this.parent.addChild(this.switchColorA);
  };
  private createTweens = (): void => {
    this.switchCircleTweenON = PIXI.tweenManager.createTween(
      this.switchPosCircle
    );
    this.switchCircleTweenON
      .from({ x: this.switchPosCircle.x })
      .to({ x: this.switchPosCircle.x + 60 });
    this.switchCircleTweenON.time = 500;
    this.switchCircleTweenON.easing = PIXI.tween.Easing.outBack();
    this.switchCircleTweenON.stop();

    this.bgColorTweenON = PIXI.tweenManager.createTween(this.switchColorB);
    this.bgColorTweenON.from({ alpha: 0 }).to({ alpha: 1 });
    this.bgColorTweenON.time = 150;
    this.bgColorTweenON.easing = PIXI.tween.Easing.outBack();
    this.bgColorTweenON.stop();

    this.switchCircleTweenOFF = PIXI.tweenManager.createTween(
      this.switchPosCircle
    );
    this.switchCircleTweenOFF
      .from({ x: this.switchPosCircle.x + 60 })
      .to({ x: this.switchPosCircle.x });
    this.switchCircleTweenOFF.time = 500;
    this.switchCircleTweenOFF.easing = PIXI.tween.Easing.outBack();
    this.switchCircleTweenOFF.stop();

    this.bgColorTweenOFF = PIXI.tweenManager.createTween(this.switchColorB);
    this.bgColorTweenOFF.from({ alpha: 1 }).to({ alpha: 0 });
    this.bgColorTweenOFF.time = 150;
    this.bgColorTweenOFF.easing = PIXI.tween.Easing.outBack();
    this.bgColorTweenOFF.stop();
  };
  public placeButton = (parent: PIXI.Container, pos: Array<number>): void => {
    parent.addChild(this.parent);
    this.parent.addChild(this.switchColorA);
    this.parent.addChild(this.label);

    // parent.addChild(this.switchColorA);
    let posX = pos[0];
    let posY = pos[1];
    this.switchColorA.x = posX + 500;
    this.switchColorA.y = posY + this.switchColorA.height / 2;
    this.label.x = posX;
    this.label.y = posY;

    // let recenter: PIXI.Graphics = new PIXI.Graphics();
    // recenter.beginFill(0x0000ff);
    // recenter.drawRect(0, 0, this.parent.width, this.parent.height);
    // recenter.endFill();
    // recenter.alpha=0.1;
    // this.parent.addChild(recenter)
  };
  public setOn = (bool: boolean): void => {
    if (bool) {
      this.switchCircleTweenON.reset();
      this.switchCircleTweenON.start();
      this.bgColorTweenON.reset();
      this.bgColorTweenON.start();
      this.isOn = true;
    } else {
      this.switchCircleTweenOFF.reset();
      this.switchCircleTweenOFF.start();
      this.bgColorTweenOFF.reset();
      this.bgColorTweenOFF.start();
      this.isOn = false;
    }
    // playButtunClick(this.activeGameData);
  };
  public getIsOn = (): boolean => {
    return this.isOn;
  };
  public setInteractive = (bool: boolean): void => {
    this.switchColorA.interactive = bool;
  };
  public setFunction = (fn: Function): void => {
    this.switchColorA.on(
      "pointertap",
      function(e: Event) {
        fn();
        // console.log(e.preventDefault)
        e.stopPropagation();
        // return e
      }.bind(this)
    );
    // this.switchColorA.on('pointertap',fn);
    // e.preventDefault();}.bind(this) );
  };
}
/*----------------------- Button */
export class Button {
  private parent: PIXI.Container;
  private image: PIXI.Sprite | PIXI.extras.AnimatedSprite;
  private buttomHitTween: PIXI.tween.Tween;

  constructor(
    imgSrc: PIXI.Sprite | PIXI.extras.AnimatedSprite,
    hitAreaPoly?: PIXI.Rectangle | PIXI.Circle
  ) {
    this.image = imgSrc;
    this.image.interactive = true;
    this.image.buttonMode = true;
    this.image.anchor.set(0.5);
    this.image.x = 0;
    this.image.y = 0;
    this.image.alpha = 1;
    // this.hitBox=hitAreaPoly;
    if (hitAreaPoly != undefined) {
      this.image.hitArea = hitAreaPoly; //this.hitBox;
    }

    // activeGameData
    // this.activeGameData = activeGameData;
    //animation when btn is clicked
    this.buttomHitTween = PIXI.tweenManager.createTween(this.image);
    this.buttomHitTween.time = 200;
    // this.buttomHitTween.delay =1000;
    this.buttomHitTween.easing = PIXI.tween.Easing.outExpo();
    this.buttomHitTween
      .from({ scale: { x: 1.025, y: 1.025 } })
      .to({ scale: { x: 0.9, y: 0.9 } });

    this.buttomHitTween.on(
      "end",
      function(sprite: PIXI.Sprite | PIXI.extras.AnimatedSprite) {
        this.reset();
        sprite.scale.set(1);

        // this.start();
      }.bind(this.buttomHitTween, this.image)
    );

    // this.image.on("mouseover", function() { this.scale.set(1.025)});
    // this.image.on("mouseout", function() { this.scale.set(1) });
    // this.image.on("mousedown",function() { this.scale.set(1) });

    // this.image.on('click', this.onButtonClicked);//not sued by default
    // this.image.on('tap', this.onButtonClicked);

    this.parent = new PIXI.Container();
  }
  // public placeButton(parent: PIXI.Container, x: number, y: number) {
  //     this.setPosition([x,y]);
  //     parent.addChild(this.image);
  //     parent.addChild(this.parent)
  //     // this.parent=parent

  // }

  public placeButton(parent: PIXI.Container, pos: Array<number>) {
    this.setPosition(pos);
    parent.addChild(this.image);
    parent.addChild(this.parent);
    // this.parent=parent
  }

  public setPosition = (pos: Array<number>): void => {
    this.image.position.set(pos[0], pos[1]);
  };

  public getPosition() {
    return [this.image.x, this.image.y];
  }
  public setFunction = (fn: Function): void => {
    // this.image.on('pointertap', fn);
    this.image.on(
      "pointertap",
      function(e: Event) {
        fn();
        // e.preventDefault();
        e.stopPropagation();
        // console.log('CLICK')
      }.bind(this)
    );
  };

  public hide = (bool: boolean): void => {
    let nScale = bool ? 0 : 1;
    this.image.scale.set(1, nScale);
  };

  // onButtonClicked=():void=> {
  //     //do nothing
  //     //can be used to play sound etc

  //     // this.buttomHitTween.reset()
  //     // this.buttomHitTween.start();
  //     // playButtunClick(this.activeGameData);

  //     // console.log("clicked")
  // }

  public setInteractive = (bool: boolean): void => {
    this.image.interactive = bool;
    this.image.buttonMode = bool;
    // console.log(bool)
  };
  public setAlpha = (alphaV: number): void => {
    this.image.alpha = alphaV;
  };

  // public setOffScale = (): void => {
  //     // this.image.off("mouseover", function() {});
  //     // this.image.off("mouseout", function() {});
  //     // this.image.off("mousedown",function() { });
  //     // this.image.off('click', this.onButtonClicked);//not used
  //     // this.image.off('tap', this.onButtonClicked);
  //     // this.buttomHitTween.from({scale:{x:1,y:1}}).to({scale:{x:1,y:1}});
  // }

  public getWidth = (): number => {
    return this.image.width;
  };
  public getHeight = (): number => {
    return this.image.height;
  };

  public getImage = (): PIXI.Sprite => {
    return this.image;
  };
  public getPosX = (): number => {
    return this.image.x;
  };
  public getPosY = (): number => {
    return this.image.y;
  };

  public setNewTexture = (newTexture: PIXI.Texture): void => {
    this.image.texture = newTexture;
  };

  public getButtonMode = (): boolean => {
    return this.image.interactive;
  };

  public setScale = (newScale: number): void => {
    this.image.scale.set(newScale);
  };
}

export class SliderBtn {
  private parent: PIXI.Container;
  private bar: PIXI.Graphics;
  private slider_grab: PIXI.Sprite;
  private max_x: number;
  private activeVal: number;
  // private stepping: number;
  private width: number;
  private dragging: boolean;
  private data: any;
  private isActive: boolean;
  private dragFn: Function;
  private dragEndFn: Function;

  constructor(parent: PIXI.Container, width: number) {
    this.isActive = false;
    this.parent = new PIXI.Container();

    parent.addChild(this.parent);
    this.width = width;

    this.bar = new PIXI.Graphics();
    this.bar.lineStyle(2, 0x000000, 1);
    this.bar.beginFill(0xfff000);
    this.bar.drawRoundedRect(-width / 2, 10, this.width, 20, 5);
    this.bar.endFill();
    this.parent.addChild(this.bar);
    let hitArea = new PIXI.Rectangle(
      -this.bar.width / 2,
      -10,
      this.bar.width,
      70
    );
    this.bar.hitArea = hitArea;
    this.bar.on("pointerdown", this.barTap);
    // .on('pointertap', this.barTap)

    this.slider_grab = new PIXI.Sprite(
      PIXI.Texture.fromImage("default_btn.png")
    );
    this.slider_grab.y = this.bar.height;
    this.slider_grab.anchor.set(0.5);
    this.bar.addChild(this.slider_grab);

    // this.slider_grab.buttonMode = true;
    // this.slider_grab.interactive = true;
    this.setButtonMode(false);

    this.slider_grab
      .on("pointerdown", this.onDragStart)
      // .on('mousedown',this.onDragStart)
      // .on('touchstart', this.onDragStart)
      // .on('pointertap', this.onDragStart)

      // events for drag move
      // .on('mousemove',  this.onDragMove)
      // .on('touchmove',  this.onDragMove)
      .on("pointermove", this.onDragMove)
      //dragEND
      // .on('mouseup', this.onDragEnd)
      // .on('mouseupoutside', this.onDragEnd)
      // .on('touchend', this.onDragEnd)
      .on("touchendoutside", this.onDragEnd)
      .on("pointerup", this.onDragEnd);
    // .on('pointerupoutside', this.onDragEnd)

    // .on('pointerdown', this.updateFromSlider)

    // .on('mousedown', onDragStart)
    // .on('touchstart', onDragStart)

    // on('mousemove', onDragMove)
    // .on('touchmove', onDragMove);

    this.activeVal = 0;
    this.max_x = this.width / 2;
    this.setNewPosSliderXFromPercentage(100);
  }

  public setPosition(newPos: Array<number>) {
    this.parent.position.set(newPos[0], newPos[1]);
  }

  private barTap = (event: any): void => {
    this.data = event.data;
    this.dataToPos();
  };

  private onDragStart = (event: any): void => {
    // store a reference to the data
    // the reason for this is because of multitouch
    // we want to track the movement of this particular touch
    this.data = event.data;
    // this.alpha = 0.5;
    this.dragging = true;
  };

  private onDragEnd = (): void => {
    // this.alpha = 1;
    if (this.dragEndFn != undefined) {
      this.dragEndFn();
    }
    this.dragging = false;
    // set the interaction data to null
    this.data = null;
    if (this.isActive) {
      this.setBtnModeBar(true);
    }
    //do the server request

    if (this.slider_grab.texture != PIXI.Texture.fromImage("default_btn.png")) {
      this.slider_grab.texture = PIXI.Texture.fromImage("default_btn.png");
    }
  };

  private onDragMove = (): void => {
    if (this.dragging) {
      this.setBtnModeBar(false);
      this.dataToPos();
      if (
        this.slider_grab.texture != PIXI.Texture.fromImage("grabHold_btn.png")
      ) {
        this.slider_grab.texture = PIXI.Texture.fromImage("grabHold_btn.png");
      }
    }
  };

  private dataToPos() {
    const newPos = this.data.getLocalPosition(this.parent);
    let activePos = newPos.x;
    let min = this.max_x * -1;
    // console.log(activePos > min && activePos < this.max_x)
    if (activePos > min && activePos < this.max_x) {
      this.slider_grab.x = newPos.x;
      this.activeVal = ((newPos.x + this.max_x) / this.width) * 100;

      if (this.dragFn != undefined) {
        this.dragFn();
      }
      // console.log(this.slider_grab.x)
    }
  }

  public getBtn = (): PIXI.Sprite => {
    return this.slider_grab;
  };

  public setNewPosSliderXFromPercentage = (val: number): void => {
    // val in percentage
    this.activeVal = val;
    let newPosX = this.percentageToValue(this.activeVal);
    this.slider_grab.x = newPosX;
    // console.log('PERCENT',val);
  };
  private percentageToValue = (val: number): number => {
    let posX = (val / 100) * this.width - this.max_x;
    return posX;
  };

  // private  valueToPercentage=(val:number):number=>
  // {
  //     let posX=((val/100)*this.width)-this.max_x
  //     return posX;
  // }

  public getSliderPos = (): number => {
    return this.activeVal;
  };

  public setButtonMode = (bool: boolean): void => {
    this.isActive = bool;
    this.setBtnModeBar(bool);
    this.slider_grab.interactive = bool;
    this.slider_grab.buttonMode = bool;

    // this.bar.interactive=bool;
    // this.bar.buttonMode=bool;
  };

  private setBtnModeBar = (bool: boolean): void => {
    this.bar.interactive = bool;
    this.bar.buttonMode = bool;
  };

  public getIsActive = (): boolean => {
    return this.isActive;
  };

  public setOnDragFn = (fn: Function): void => {
    this.dragFn = fn;
  };

  public setOnDragEndFn = (fn: Function): void => {
    this.dragEndFn = fn;
  };
  public setHidden=(bool:boolean):void=>
  {
   
    this.parent.alpha=bool?0:1;
    this.parent.scale.set(bool?0:1);
    this.setButtonMode(bool);
  }
}
